export default "__VITE_ASSET__273O6kXX__"